import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../context/AuthProvider";
import { AppShell, Header, Text, Button } from "@mantine/core";
import CreateProjectPage from "./CreateProjectPage";
import {ReactComponent as Logo} from '../icons/zeitview_logo.svg'

const Home = () => {
    const { setAuth } = useContext(AuthContext);
    const navigate = useNavigate();

    const logout = async () => {
        setAuth({});
        navigate('/login');
    }

    return (
        <AppShell fixed header={<Header height={60} padding="xs">
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: 10 }}>
                <Logo style={{width: 100, height: 40}}/>
                <Text size="xl" variant="gradient" gradient={{ from: "red", to: "blue", deg: 138}}>Autoloader</Text>
                <Button padding="xs" variant="filled" radius="lg" size="md" onClick={logout}>Sign Out</Button>
            </div>
            </Header>}>
            <CreateProjectPage />
          </AppShell>
    )
}

export default Home;
